// ========================
// == Masterplan card modal: the state list opens one state's community table,
// == and the back button returns to the list. Markup: masterplan_card.html

/** Show the state list again. Returns the panel that was open, if any. */
const showStateList = (container) => {
    const panel = container.querySelector("[data-mp-state-panel]:not([hidden])");
    if (!panel) {
        return null;
    }
    panel.hidden = true;
    container.querySelector("[data-mp-state-list]").hidden = false;
    container.classList.remove("is-state-open");
    container.closest(".modal-body").scrollTop = 0;
    return panel;
};

const showStatePanel = (container, panel) => {
    container.querySelector("[data-mp-state-list]").hidden = true;
    panel.hidden = false;
    container.classList.add("is-state-open");
    container.closest(".modal-body").scrollTop = 0;
    panel.querySelector(".plans-state-scroll").scrollTop = 0;
    panel.querySelector("[data-mp-state-back]").focus();
};

document.addEventListener("click", (event) => {
    const openBtn = event.target.closest("[data-mp-state-open]");
    if (openBtn) {
        const panel = document.getElementById(openBtn.getAttribute("aria-controls"));
        showStatePanel(openBtn.closest("[data-mp-states]"), panel);
        return;
    }

    const backBtn = event.target.closest("[data-mp-state-back]");
    if (backBtn) {
        const container = backBtn.closest("[data-mp-states]");
        const panel = showStateList(container);
        // Return focus to the state the user came from
        container.querySelector(`[aria-controls="${panel.id}"]`).focus();
    }
});

// Reopening the modal always starts at the state list
document.addEventListener("hidden.bs.modal", (event) => {
    const container = event.target.querySelector("[data-mp-states]");
    if (container) {
        showStateList(container);
    }
});

// END Masterplan card modal
// ========================
